const dropLineStyle = {
  height: '0.25rem',
  backgroundColor: '#1976d2',
  borderRadius: '0.125rem',
  width: '100%',
  transition: 'background 0.2s',
};

export const dropLineAboveStyle = {
  ...dropLineStyle,
  marginBottom: '0.25rem',
};

export const dropLineBelowStyle = {
  ...dropLineStyle,
  marginTop: '0.25rem',
};
